import { DesktopFilterService } from '../../../services/desktop-filter.service';

export class DesktopFiltersLayoutRenderer {
  private isDestroyed = false;

  private desktopFilterService: DesktopFilterService;

  private readonly containerElement!: HTMLElement;
  private readonly additionalFiltersContainer!: HTMLElement;
  private dropdownElements: HTMLElement[] = [];

  constructor(
    desktopFilterService: DesktopFilterService,
    containerElement: HTMLElement,
    additionalFiltersContainer: HTMLElement
  ) {
    this.desktopFilterService = desktopFilterService;
    this.containerElement = containerElement;
    this.additionalFiltersContainer = additionalFiltersContainer;
  }

  start() {
    window.requestAnimationFrame(this.loop.bind(this));
  }

  private loop() {
    this.update();

    if (!this.isDestroyed) {
      window.requestAnimationFrame(this.loop.bind(this));
    }
  }

  update() {
    const containerRect = this.containerElement.getBoundingClientRect();

    const lastDropdown =
      this.dropdownElements[this.dropdownElements.length - 1];
    const lastDropdownRect = lastDropdown.getBoundingClientRect();

    const isAdditionalFiltersVisible =
      containerRect.right < lastDropdownRect.right;
    this.updateElementVisibility(
      this.additionalFiltersContainer,
      isAdditionalFiltersVisible
    );

    const additionalFiltersRect =
      this.additionalFiltersContainer.getBoundingClientRect();
    const rightEdgeX = isAdditionalFiltersVisible
      ? containerRect.right - additionalFiltersRect.width
      : containerRect.right;

    for (let i = this.dropdownElements.length - 1; i > 0; i--) {
      const dropdownElement = this.dropdownElements[i];
      const dropdownRect = dropdownElement.getBoundingClientRect();
      const filterName = dropdownElement.dataset.filter || '';

      const isVisible = dropdownRect.right < rightEdgeX;
      this.updateElementVisibility(dropdownElement, isVisible);
      this.desktopFilterService.activeAdditionalFilters.set(
        filterName,
        !isVisible
      );

      if (!isVisible) {
        this.additionalFiltersContainer.style.transform = `translateX(${
          dropdownRect.left - containerRect.left
        }px)`;
      }
    }

    this.desktopFilterService.requestLayoutUpdate();
  }

  private updateElementVisibility(element: HTMLElement, isVisible: boolean) {
    if (isVisible) {
      element.style.opacity = '';
      element.style.pointerEvents = '';
    } else {
      element.style.opacity = '0';
      element.style.pointerEvents = 'none';
    }
  }

  setDropdownElements(elements: HTMLElement[]) {
    this.dropdownElements = elements;
  }

  destroy() {
    this.isDestroyed = true;
  }
}
